module.exports = __webpack_public_path__ + "static/img/logo2.f1fd711.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo2.png
// module id = 3bGJ
// module chunks = 16